import { render, staticRenderFns } from "./FrrIcon.vue?vue&type=template&id=144e6f52&"
import script from "./FrrIcon.vue?vue&type=script&lang=js&"
export * from "./FrrIcon.vue?vue&type=script&lang=js&"
import style0 from "./FrrIcon.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports